import api from '../services/api';

/**
 * Log a user action from the frontend.
 * Fires-and-forgets — never throws, never blocks the UI.
 */
export const logActivity = (action, entityType = null, entityId = null, description = null) => {
  api.post('/activity-log', {
    action,
    entity_type: entityType  || undefined,
    entity_id:   entityId    ? String(entityId) : undefined,
    description: description || undefined,
  }).catch(() => {});
};
